import moment from 'moment';
import {
  PRODUCT_ANNUITY_LIQUID_LIFETIME,
  PRODUCT_ANNUITY_LIFETIME,
  PRODUCT_CARE_PLUS,
} from './constants';

const formatValue = (fieldKey, policy) => {
  switch (fieldKey) {
    case 'ate':
      if (policy.ate === 0) {
        return 'No';
      }
      return `${policy.ate}%`;
    case 'balanceAmountClosed':
      return formatCurrency(0);
    case 'nextPaymentAmount':
    case 'balanceAmount':
    case 'purchasePrice':
      return formatCurrency(policy[fieldKey]);
    case 'fixedRate':
      return `${policy[fieldKey].toFixed(2)}% p.a.`;
    case 'closedDate':
    case 'nextPaymentDate':
    case 'openDate':
      if (!policy[fieldKey]) {
        return 'N/A';
      }
      if (fieldKey === 'nextPaymentDate') {
        if (isDateBeforeToday(policy[fieldKey])) {
          return 'Suspended';
        }
        if (policy.isRBACashLinked && !policy.beneficiaryDetails) {
          return `${formatDate(policy[fieldKey])} *`;
        }
      }

      return formatDate(policy[fieldKey]);
    case 'maturityDate':
      if (!policy.maturityDetails || !policy.maturityDetails[fieldKey]) {
        return 'N/A';
      }
      return formatDate(policy.maturityDetails[fieldKey]);
    case 'maturityValue':
      if (!policy.maturityDetails || policy.maturityDetails[fieldKey] === undefined) {
        return 'N/A';
      }
      return formatCurrency(policy.maturityDetails[fieldKey]);
    case 'nextPaymentClosed':
      return formatCurrency(0);
    case 'unitPriceClosed':
      return formatUnitPrice(0);
    case 'isCommutable':
      if (policy.isCommutable) {
        return 'Yes';
      }
      return 'No';
    case 'taxStatus':
      return policy.taxDetails[0].taxStatus;
    case 'tfnProvided':
      if (policy.taxDetails[0].tfnProvided) {
        return 'Yes';
      }
      return 'No';
    case 'term':
      if (
        policy.accountProductType === PRODUCT_ANNUITY_LIQUID_LIFETIME ||
        policy.accountProductType === PRODUCT_ANNUITY_LIFETIME ||
        policy.accountProductType === PRODUCT_CARE_PLUS
      ) {
        return 'Lifetime';
      }
      if (policy[fieldKey] === 1) {
        return `${policy[fieldKey]} year`;
      }
      return `${policy[fieldKey]} years`;
    case 'isTransitionToRetirement':
      if (policy.isTransitionToRetirement) {
        return 'Yes';
      }
      return 'No';
    case 'unitPrice':
      if (policy.unitPrice || policy.unitPrice === 0) {
        return formatUnitPrice(policy.unitPrice);
      }
      return formatUnitPrice(policy.investmentOptions[0].unitPrice);
    case 'unitPriceDate':
      if (policy.unitPriceDate) {
        return formatDate(policy.unitPriceDate);
      }
      return formatDate(policy.investmentOptions[0].unitPriceDate);
    case 'numberOfUnits':
    case 'units':
      if (policy.units && policy.units === 0) {
        return formatUnits(0);
      }
      if (policy.numberOfUnits && policy.numberOfUnits === 0) {
        return formatUnits(0);
      }
      if (policy.units) {
        return formatUnits(policy.units);
      }
      if (policy.investmentOptions[0].numberOfUnits === 0) {
        return formatUnits(0);
      }
      return formatUnits(policy.investmentOptions[0].numberOfUnits);
    case 'numberOfUnitsClosed':
      return formatUnits(0);
    case 'withdrawalGuarantee':
      if (
        policy.accountProductType === PRODUCT_ANNUITY_LIQUID_LIFETIME &&
        policy.liquidityMode === 'Regular'
      ) {
        return formatCurrency(policy.withdrawalGuarantee);
      }
      return 'N/A';
    case 'withdrawalPeriodEnds':
      if (policy.liquidityMode === 'Enhanced') {
        return 'N/A';
      }
      return formatDate(policy[fieldKey]);
    case 'upfrontASFWithGST':
    case 'regularASFPerPaymentAmt':
      if(policy[fieldKey]){
        return formatCurrency(policy[fieldKey]);
      }
      return '$0.00';
    case 'regularASFType':
      if (policy.regularASFType) {
        return policy[fieldKey]
      }
      return 'N/A';
    case 'regularASFConsentExpiryDate':
      if (policy.regularASFConsentExpiryDate) {
        return formatDate(policy[fieldKey])
      }
      return 'N/A';
    default:
      return policy[fieldKey];
  }
};

export const formatCurrency = (number) => {
  return `$${number.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')}`;
};

export const formatUnitPrice = (number) => {
  return `$${number.toFixed(4)}`;
};

export const formatUnits = (number) => {
  if (number === 0) {
    return number.toFixed(4);
  }
  return number.toLocaleString(undefined, { minimumFractionDigits: 4 });
};

const formatDate = (date) => {
  return moment(date).format('D MMM YYYY');
};

const isDateBeforeToday = (date) => {
  return moment(date).isBefore(moment(), 'day');
};

export default formatValue;
